import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Model, WhenModel } from '@morningtrain/react-resources'
import { Can } from '@morningtrain/react-auth'
import { useEnvValue } from '@morningtrain/react-helpers'
import EmployeeOnboardingInfo from 'pages/app/onboarding/partials/EmployeeOnboardingInfo'
import { Link } from '@morningtrain/react-navigation'

export default function MyOnboardingDashboardWidget () {
  const [myId] = useEnvValue('user.id')
  return (
    <Can permission='api.shifts.schedule_slot.mine'>
      <Widget>
        <Translator namespace='dashboard.my_onboarding'>

          <Model resourceName='onboarding.onboarding_checklists' operationName='employee' id={myId} clean>
            <WhenModel>
              <div>
                <UI.CardHeader withMargin={false}>
                  <UI.SecondaryHeading>
                    <Translation name='title' />
                  </UI.SecondaryHeading>
                  <UI.ButtonWrap>
                    <Link route='app.onboarding.personal'>
                      <UI.Button color='outlineDark'>
                        <Translation name='actions.go_to_onboarding' />
                      </UI.Button>
                    </Link>
                  </UI.ButtonWrap>
                </UI.CardHeader>
                <Translator namespace='onboarding'>
                  <UI.Card>
                    <EmployeeOnboardingInfo />
                  </UI.Card>
                </Translator>
              </div>
            </WhenModel>
          </Model>

        </Translator>
      </Widget>
    </Can>
  )
}
